<script>
	import { t } from '$lib/translations'
	import BasicsBlogView01 from '../cms/BasicsBlogView01/BasicsBlogView01.svelte'

	export let otherArticles = null
	export let categoryTitle = null
</script>

{#if otherArticles}
	<div class="my-12 lg:mt-24">
		<BasicsBlogView01
			articles={{ data: otherArticles }}
			title={categoryTitle
				? `${t('blog.otherArticlesCategory')} ${categoryTitle?.toLowerCase()}`
				: t('web.blog.title')}
		/>
	</div>
{/if}

<style lang="scss">
</style>
